import FileDownloaderButton from 'components/FileDownloaderButton';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { showFailureToast, showSuccessToast } from 'lib/ToastHelper';
import { debounce } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import { Row, Col, Input } from 'reactstrap';
import { companyIdAtom } from 'views/state';

import DashboardActions from './DashboardActions';
import { getExportCsvUrlParams } from './helper';
import {
  checkedListAtom,
  orderbyAtom,
  orderingAtom,
  paginationConfigAtom,
  searchPhraseFilterAtom,
  selectedWebAppsFilterAtom,
} from './state';
import { WAFilter } from '../config';
import { waRefreshAtom } from '../state';

const WebAppsFilterOptions = [
  { value: WAFilter.ACTIVE, label: 'Active' },
  { value: WAFilter.INACTIVE, label: 'Inactive' },
  { value: WAFilter.DELETED, label: 'Deleted (Aged Out or Manual)' },
];

const colorStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: 'white',
    cursor: 'pointer',
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    // const color = chroma(data.color);
    return {
      ...styles,
      textAlign: 'left',
      cursor: 'pointer',
    };
  },
};

const Filters = () => {
  // PRESERVED STATE
  const [orderBy, setOrderBy] = useAtom(orderbyAtom);
  const companyId = useAtomValue(companyIdAtom);
  const [selectedWebAppsFilter, setSelectedWebAppsFilter] = useAtom(
    selectedWebAppsFilterAtom,
  );
  const [searchPhraseFilter, setSearchPhraseFilter] = useAtom(
    searchPhraseFilterAtom,
  );

  const [selectedRowIds, setSelectedRowIds] = useAtom(checkedListAtom);
  const ordering = useAtomValue(orderingAtom);
  const [paginationConfig, setPaginationConfig] = useAtom(paginationConfigAtom);

  const setWARefresh = useSetAtom(waRefreshAtom);

  // NORMAL STATE
  const [searchPhrase2, setSearchPhrase2] = useState('');

  const searchField = useRef<any>();

  useEffect(() => {
    if (searchPhraseFilter !== searchPhrase2)
      setSearchPhrase2(searchPhraseFilter);
  }, [searchPhraseFilter]);

  const debouncedSearch = React.useRef(
    debounce(async (newSearchPhrase, oldSearchPhrase, setSearchPhrase) => {
      if (newSearchPhrase !== oldSearchPhrase) {
        setPaginationConfig({ ...paginationConfig, page: 1 });
        setSearchPhrase(newSearchPhrase);
        setSelectedRowIds([]);
      }
    }, 1000),
  ).current;

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  return (
    <Row className="text-left">
      <Col md="4" sm="12">
        <div className="d-flex align-items-center justify-content-end">
          <DashboardActions />
          <FileDownloaderButton
            buttonId="was_export_all"
            iconClass="fa fa-file-export"
            tooltip="Export CSV data for filtered Web Application"
            fileName={`${localStorage
              .getItem('currentCompany')
              ?.toLocaleLowerCase()}_web_applications.csv`}
            method="GET"
            downloadUrl="web_apps/export-csv"
            urlParams={getExportCsvUrlParams(
              companyId,
              orderBy,
              selectedWebAppsFilter,
              searchPhraseFilter,
              selectedRowIds,
            )}
            onSuccessCallback={() =>
              showSuccessToast('File download completed.')
            }
            onFailureCallback={(message) => showFailureToast(message)}
          />
        </div>
      </Col>
      <Col md="3" sm="12" className="text-left" style={{ paddingRight: '0px' }}>
        {/* <Label>Type</Label> */}
        <Select
          id="WebAppsTypeDropdown"
          className="custom-360-dropdown"
          value={WebAppsFilterOptions.find(
            (x) => x.value === selectedWebAppsFilter,
          )}
          onChange={(e) => {
            if (e) {
              setPaginationConfig({ ...paginationConfig, page: 1 });
              setSelectedWebAppsFilter(e.value);
              setSelectedRowIds([]);
            }
          }}
          styles={colorStyles}
          options={WebAppsFilterOptions}
        />
      </Col>
      <Col md="5" sm="12" className="text-left">
        <Input
          ref={searchField}
          id="WebAppsSearch"
          type="text"
          list="data"
          value={searchPhrase2}
          placeholder="Search Web Apps"
          onChange={(e) => {
            setSearchPhrase2(e.target.value);
            debouncedSearch(
              e.target.value,
              searchPhraseFilter,
              setSearchPhraseFilter,
            );
          }}
        />
      </Col>
    </Row>
  );
};

export default Filters;
